import {useState, useEffect} from "react";
import { toast } from 'react-toastify';
import { useHistory } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import logoLight from "../../../images/logo-light.svg";

const Header = ({templateName, createNewTemplate, setTemplateName, saveTemplate, 
                templates, setSelectedTemplate, loadTemplate, showRenameModal, setShowRenameModal}) => {

    const history = useHistory();
    toast.configure()
    const [tempName, setTempName] = useState(templateName);

    useEffect(() => {
        setTempName(templateName)
    }, [templateName])

    const saveTemplateName = () => {
        if(tempName !== "" && tempName !== null && tempName !== undefined) {
            setTemplateName(tempName)
            setShowRenameModal(false);
        } else {
            toast.error("Template name cannot be blank.", {
                position: 'top-left',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: false
              })
        }
    }

    return (
        <header className="editor-header">
            <div className="container-fluid d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                    <button className="btn p-0" onClick={(e) => history.push("/")}>
                        <img src={logoLight} className="img-fluid" width="180"/>
                    </button>
                    <span className="navbar-brand mb-0 text-light fw-bold">
                        <u>
                            Template Creator
                        </u>
                    </span>
                    <span className="text-light ml-4">
                        { templateName !== "" ? templateName : "New unsaved template*" }
                    </span>
                    <button className="btn btn-sm btn-black text-white border border-light ml-2 px-2 py-1" onClick={() => setShowRenameModal(true)}>
                        <small>rename</small>
                    </button>
                </div>
                <div className="d-flex align-items-center">
                    <small className="text-light">Saved templates: </small>
                    <select className="custom-select bg-white ml-3" name="" id="" onChange={e => setSelectedTemplate(e.target.value)}>
                        <option value="" disabled selected>Select Template</option>
                        {
                            templates?.map(t => { 
                                return ( <option value={t?.template_id} >{t?.template_name}</option> )
                            })
                        }
                    </select>
                    <button className="btn btn-sm py-1 px-2 btn-light border border-dark border m-2 mr-4" onClick={ loadTemplate }>Open Template</button>  
                    <button className="btn btn-sm py-1 px-2 btn-info m-2" onClick={ createNewTemplate }>New Template</button>                                      
                    <button className="btn btn-sm py-1 px-2 btn-success m-2" onClick={ saveTemplate }>Save Template</button>
                </div>
            </div>

            {
                showRenameModal
                ?
                <div id="rename-template-modal" className="modal d-flex overlay-bg">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Rename Template</h5>
                                <button type="button" class="close" onClick={() => setShowRenameModal(false)} aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <input className="mb-3" type="text" value={tempName} onChange={(e) => {setTempName(e.target.value)}}/>
                                {
                                    null ?
                                    <p className="text-success">Image uploaded successfully</p>
                                    :
                                    null
                                }
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-outline-danger" onClick={() => setShowRenameModal(false)}>Cancel</button>
                                <button type="button" class="btn  btn-info border" onClick={saveTemplateName}>Save name</button>
                            </div>
                        </div>
                    </div>
                </div>
                : null            
            }
        </header>
    )
}

export default Header;